import { Box, Button, Card, CardContent, Grid, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';

interface BaseCardProps {
  title: string;
  price: string;
  resellerPrice?: string;
  description: string;
  tooltip?: string;
  onSave?: () => void;
  onSelect?: () => void;
  buttonText: string;
  expandedContent?: React.ReactNode;
  disabled?: boolean;
}

const BaseCard = ({
  title,
  price,
  resellerPrice,
  description,
  tooltip,
  onSave,
  onSelect,
  buttonText,
  expandedContent,
  disabled = false,
}: BaseCardProps) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <Grid item xs={12} md={6} lg={4}>
      <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }} variant="outlined">
        <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              mb: 2,
            }}
          >
            <Typography variant="h6" component="div">
              {title}
            </Typography>
            <Box sx={{ textAlign: 'right' }}>
              <Typography
                variant="body2"
                color={resellerPrice ? undefined : 'secondary'}
                sx={{ fontWeight: 'bold' }}
              >
                {price}
              </Typography>
              {resellerPrice && (
                <Typography variant="body2" color="secondary" sx={{ fontWeight: 'bold' }}>
                  ÅF: {resellerPrice}
                </Typography>
              )}
            </Box>
          </Box>

          <Tooltip title={tooltip} placement="top" arrow>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2, flex: 1 }}>
              {description}
            </Typography>
          </Tooltip>

          <Box sx={{ mt: 'auto' }}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              disabled={disabled}
              onClick={() => {
                if (onSelect) {
                  onSelect();
                } else if (expandedContent) {
                  setExpanded(true);
                } else if (onSave) {
                  onSave();
                }
              }}
            >
              {buttonText}
            </Button>
          </Box>

          {expanded && expandedContent}
        </CardContent>
      </Card>
    </Grid>
  );
};

export default BaseCard;
